var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NbCardBox',[_c('h4',{staticClass:"heading-4 mb-4"},[_vm._v(_vm._s(_vm.$t("dashboardPage.totalSales")))]),_c('div',{staticClass:"box mb-4"},[_vm._v(_vm._s(_vm.totalAmount))]),_c('div',{ref:"chart",staticClass:"chart"})])
}
var staticRenderFns = []

export { render, staticRenderFns }